(() => {
 'use strict';
 if (window.vmGiftsLoaded) return;
 window.vmGiftsLoaded = true;
 let busy = false;
 const root = window.Shopify?.routes?.root || '/';
 const areas = () => Array.from(document.querySelectorAll('[data-vm-gifts]'));
 function lock(value) {
  busy = value;
  areas().forEach(area => area.querySelectorAll('button, select').forEach(control => {
   if (value) { control.dataset.wasDisabled = String(control.disabled); control.disabled = true; }
   else { control.disabled = control.dataset.wasDisabled === 'true'; delete control.dataset.wasDisabled; }
  }));
 }
 async function request(path, options = {}) {
  const response = await fetch(root + path, { cache: 'no-store', ...options });
  const data = await response.json();
  if (!response.ok) throw new Error(data.description || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.');
  return data;
 }
 const post = data => ({ method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
 function refresh(cart) {
  const core = window.themeCore;
  if (core?.EventBus) {
   core.cartObject = cart;
   core.EventBus.emit('cart:updated', { ...cart, action: 'update', params: [{ noOpen: true }] });
   core.EventBus.emit('header:update-item-count', { item_count: cart.item_count });
  }
 }
 function discountApplied(line, area) {
  const kind = area.dataset.kind, value = Number(area.dataset.value);
  const price = Number(line.original_line_price);
  if (!Number.isFinite(price) || price <= 0) return false;
  const allocations = line.line_level_discount_allocations || [];
  const matching = allocations.filter(a => a.discount_application?.title === area.dataset.discountTitle);
  const actual = matching.reduce((sum, a) => sum + Number(a.amount || 0), 0);
  if (!matching.length || actual <= 0) return false;
  if (kind === 'free') return line.final_line_price === 0 && actual >= price;
  if (!Number.isFinite(value) || value <= 0) return false;
  if (kind === 'percent' && value <= 100) return actual >= Math.floor(price * value / 100);
  if (kind === 'amount') return actual >= Math.min(price, Math.round(value * 100) * line.quantity);
  return false;
 }
 document.addEventListener('change', event => {
  const select = event.target.closest('[data-gift-variant]');
  if (!select) return;
  const card = select.closest('[data-gift-product]');
  const option = select.selectedOptions[0];
  if (!card || !option) return;
  ['price', 'original', 'saving'].forEach(key => {
   const node = card.querySelector('[data-gift-' + key + ']');
   if (node) node.textContent = option.dataset[key];
  });
  card.querySelectorAll('[data-gift-link]').forEach(link => { link.href = option.dataset.url; });
 });
 document.addEventListener('click', async event => {
  const button = event.target.closest('[data-gift-add]');
  const area = button?.closest('[data-vm-gifts]');
  if (!area || busy || event.defaultPrevented) return;
  const campaign = area.dataset.vmGifts;
  if (!/^(?:[1-9]|10)$/.test(campaign)) return;
  const card = button.closest('[data-gift-product]');
  const status = area.querySelector('[data-gift-status]');
  let variantId, properties = {};
  if (button.hasAttribute('data-campaign-form-add')) {
   const form = button.closest('form');
   if (!form || !form.reportValidity()) return;
   const data = new FormData(form);
   if (Number(data.get('quantity') || 1) !== 1) { status.textContent = 'Kampanyalı seçim için ürün adedini 1 yapın. Her seçim ayrı eklenir.'; return; }
   if (data.get('selling_plan')) { status.textContent = 'Abonelik seçeneğinde bu teklif kullanılamıyor.'; return; }
   variantId = Number(data.get('id'));
   for (const [key, value] of data.entries()) {
    const match = key.match(/^properties\[(.+)\]$/);
    if (match && typeof value === 'string') properties[match[1]] = value;
    if (match && typeof value !== 'string' && value.size > 0) { status.textContent = 'Dosya yüklemeli ürünlerde kampanyalı hızlı ekleme desteklenmiyor.'; return; }
   }
   const summary = form.querySelector('[data-personalization-summary]');
   if (summary && !summary.disabled && !summary.value.trim()) { status.textContent = 'Lütfen kişiselleştirme bilgilerini tamamlayın.'; return; }
  } else variantId = Number(card.querySelector('[data-gift-variant]')?.value);
  if (!Number.isSafeInteger(variantId) || variantId <= 0) { status.textContent = 'Lütfen bir ürün seçeneği seçin.'; return; }
  lock(true); status.textContent = 'Kampanya kontrol ediliyor…';
  let attempted = false, verified = false;
  // Isolate this addition even if Shopify merges or splits discounted lines.
  let token;
  try {
   token = window.crypto.randomUUID();
   const sections = await request('cart?sections=vm-gift-state');
   if (typeof sections['vm-gift-state'] !== 'string') throw new Error('Kampanya koşulları kontrol edilemedi.');
   const state = new DOMParser().parseFromString(sections['vm-gift-state'], 'text/html').querySelector(`[data-vm-gift-state="${campaign}"]`);
   if (!state) throw new Error('Bu kampanya şu anda kullanılamıyor. Sayfayı yenileyin.');
   const limit = Number(state.dataset.limit), claimed = Number(state.dataset.claimed);
   if (!Number.isInteger(limit) || limit < 0 || !Number.isInteger(claimed) || claimed < 0) throw new Error('Kampanya koşulları kontrol edilemedi.');
   if (state.dataset.qualified !== 'true' || limit === 0) { status.textContent = 'Önce bu kampanyayı kazandıran ürünü sepetine ekle.'; return; }
   if (claimed >= limit) { status.textContent = 'Bu kampanyanın seçim hakkı kullanılmış. Değiştirmek için önce seçtiğin ürünü sepetinden kaldırabilirsin.'; return; }
   const before = await request('cart.js');
   if (area.dataset.kind === 'amount' && before.currency !== area.dataset.currency) throw new Error('Bu sabit tutarlı teklif mağazanın ana para biriminde kullanılabilir.');
   if (before.items.some(item => String(item.product_id) === card.dataset.giftProduct && item.properties?._vm_campaign !== campaign)) { status.textContent = 'Bu ürün zaten sepetinde. Farklı bir ürün seçebilir veya önce sepetindeki ürünü kaldırabilirsin.'; return; }
   const currentCount = before.items.filter(item => item.properties?._vm_campaign === campaign).reduce((sum, item) => sum + item.quantity, 0);
   if (currentCount >= limit) { status.textContent = 'Bu kampanyanın seçim hakkı kullanılmış.'; return; }
   properties = { ...properties, _vm_campaign: campaign, _vm_offer_token: token, _vm_cart_offer: 'true' };
   if (area.dataset.kind === 'free') properties._vm_gift = 'true';
   attempted = true;
   await request('cart/add.js', post({ items: [{ id: variantId, quantity: 1, properties }] }));
   let cart = await request('cart.js');
   const lines = cart.items.filter(item => item.properties?._vm_offer_token === token);
   if (!lines.length) throw new Error('Eklenen ürün doğrulanamadı.');
   if (lines.some(item => !discountApplied(item, area))) {
    let remaining = lines.length;
    while (remaining-- > 0) {
     const line = cart.items.find(item => item.properties?._vm_offer_token === token);
     if (!line) break;
     cart = await request('cart/change.js', post({ id: line.key, quantity: 0 }));
    }
    if (cart.items.some(item => item.properties?._vm_offer_token === token)) throw new Error('Ürün kaldırma doğrulanamadı.');
    verified = true; refresh(cart);
    status.textContent = 'Bu kampanyanın indirimi uygulanamadığı için ürün sepete bırakılmadı.';
    return;
   }
   verified = true; refresh(cart);
   status.textContent = area.dataset.kind === 'free' ? 'Hediyen ücretsiz olarak sepetine eklendi.' : 'Ürün kampanya indirimiyle sepetine eklendi.';
  } catch (error) {
   status.textContent = error.message;
   if (attempted && !verified) {
    try {
     const cart = await request('cart.js'); refresh(cart);
     if (cart.items.some(item => item.properties?._vm_offer_token === token)) status.textContent = 'İşlem doğrulanamadı. Devam etmeden önce sepetindeki ürün ve fiyatı kontrol et.';
    } catch (_) { status.textContent = 'Bağlantı kesildi. Tekrar denemeden önce sepetindeki ürün ve fiyatı kontrol et.'; }
   }
  } finally { lock(false); }
 });
})();
